/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect, useRef } from 'react';
import Flink from '~/components/shared/flink'
import { useSwipeable } from 'react-swipeable'
import { useTheme } from '~/contexts/ThemeContext'
import { altText } from '~/utils/helpers'
import ImgGridAct from '~/helpers/img-grid'
import { imgSize } from '~/utils/helpers'

import VideoBg from '~/components/video/bg'
import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/shared/img_grid.module.scss";

const ImgGrid = ({ media, handle, title, wr_class, gender, linked, tile_ind, toggleFlats, onHandleSelect=false, gaInteract=false, vintage=false }) => {
  const { isMobile, isTouches } = useTheme()

  const [isOff, setIsOff] = useState(false)
  const [openGrid, setOpenGrid] = useState(false)
  const [changeSrc, setChangeSrc] = useState(false)
  const [firstLoad, setFirstLoad] = useState(true)

  const total = media && (media.length - 1)

  const is_pdp = toggleFlats === 'pdp'
  const gridRef = useRef(null)
  const firstRef = useRef(null)

  const checkShow = (hover=false) => {
    if (is_pdp ) return 0

    let firstimg
    let hoverimg
    const has_new = media.find(x => !!x.face || !!x.hover)
    if (has_new) {
      firstimg = media.findIndex( x => x.face)
      hoverimg = media.findIndex( x => x.hover)
      if (!hover) {
        hoverimg = media.filter(x => x !== firstimg)[0] || null
      }
    } else {
      const def_flat = !toggleFlats ? 'flat' : toggleFlats
      const flat_ind = media.findIndex( x => !!x.flat)
      let notflat_ind = media.findIndex( x => x.alt && x.alt.toLowerCase().includes('model'))
      if (notflat_ind < 0) notflat_ind = media.findIndex( x => !x.flat )
      const nextnot_ind = media.findIndex( (x, index) => index !== notflat_ind && !x.flat )

      firstimg = 0
      hoverimg = media.length > 1 ? 1 : 0

      if ( media.length > 1 && def_flat === 'flat') {
        firstimg = flat_ind >= 0 ? flat_ind : notflat_ind >= 0 ? notflat_ind : 0
        hoverimg = flat_ind >= 0 && notflat_ind >= 0 ? notflat_ind : nextnot_ind
      }
      if ( media.length > 1 && def_flat !== 'flat') {
        firstimg = notflat_ind >= 0 ? notflat_ind : 0
        hoverimg = flat_ind >= 0 ? flat_ind : nextnot_ind >= 0 ? nextnot_ind : 1
      }
      if (gender === 'u' && media.length > 1) {
        firstimg = flat_ind >= 0 ? flat_ind : notflat_ind >= 0 ? notflat_ind : 0
        hoverimg = flat_ind >= 0 && notflat_ind >= 0 ? notflat_ind : nextnot_ind
      }
      if (gender === 'w' && media.length > 0 && media[0].type === 'VIDEO') {
        firstimg = 0
        hoverimg = 1
      }
    }

    return hover ? hoverimg : firstimg
  }


  const handleMouseEnter = (entering=true) => {
    if (isOff || openGrid || media.length < 2) return
    setCurrShow(checkShow(entering))
    setChangeSrc(true)
  };

  const imgsrc_size = (item) => {
    if (!is_pdp) return imgSize(item.src,700)
    return !isMobile ? imgSize(item.src,1200) : imgSize(item.src,900)
  }

  const [currShow, setCurrShow] = useState(checkShow())
  const [dot, setDot] = useState(checkShow())

  const swipers = useSwipeable({
    onSwiping: (e) => {
      if (!isTouches) return
    },
    onSwipedLeft: (e) => {
      if (!isTouches ) return
      img_forw()
    },
    onSwipedRight: (e) => {
      if (!isTouches) return
      img_back()
    },
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: true,
    delta: {
      up: 1000,
      down: 1000,
    },
  });

  const img_forw = () => {
    setIsOff(true)
    const new_pos = (currShow + 1) > total ? 0 : currShow + 1 
    setCurrShow(new_pos)
    setDot(new_pos)
    if (gaInteract) gaInteract('image grid swipe') 
  }

  const img_back = () => {
    setIsOff(true)
    const new_pos = currShow - 1 < 0 ? total : currShow - 1 
    setCurrShow(new_pos)
    setDot(new_pos)
    if (gaInteract) gaInteract('image grid swipe') 
  }

  const handleGrid = () => {
    if (!openGrid && gaInteract) gaInteract('image grid open') 
    setOpenGrid(!openGrid)
    setChangeSrc(true)
  }

  const handleClick = (e) => {
    openGrid ? e.preventDefault() : onHandleSelect()
  }

  const handleShow = (index) => {
    if (!openGrid) return
    setCurrShow(index)
    setOpenGrid(!openGrid)
    setIsOff(true)
  }

  const getTrans = (index) => {
    return openGrid ? ImgGridAct.imagesGrid(media.length, index) : 'none'
  }

  useEffect(() => {
    setFirstLoad(false)
    
    setTimeout(() => {
      if (firstRef && firstRef.current) firstRef.current.setAttribute('src', firstRef.current.getAttribute('data-src'))
    }, 400)
    
  }, []);

  useEffect(() => {
    const show = checkShow()
    setCurrShow( show )
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleFlats]);

  useEffect(() => {
    if ( !changeSrc || !gridRef.current ) return
    
    gridRef.current.querySelectorAll('img').forEach( x => {  
      x.setAttribute('src', x.getAttribute('data-src'))
    })
  }, [changeSrc]);

  const content = (
    <>
      {media.map( (item, index) => {

        const is_show = index === currShow 
        const is_hov = index === checkShow(true) 

        switch (item.type) {
          case 'IMAGE':

            return (
              <img 
                key={`${handle}imggrid_${index}`}
                src={(changeSrc || is_show || is_hov) ? imgsrc_size(item) : undefined }
                data-src={imgsrc_size(item)}
                alt={altText(item.alt, title)}
                className={`${styles.grid_img} img_${index} ${is_show ? styles.show : ''} ${is_hov ? 'foo' : ''}`} 
                style={{
                  transform: getTrans(index), 
                  zIndex: is_show ? '2' : '1',
                  opacity: is_show || openGrid ? '1' : '0', 
                  visibility: !is_show && firstLoad ? 'hidden' : 'unset'
                }}
                ref={is_show ? firstRef : undefined}
                width="400" 
                height="532" 
                loading={index < 2 ? undefined : "lazy"}
                decode="async"
                role={openGrid ? 'button' : undefined}
                tabIndex={openGrid ? '0' : undefined}
                onClick={openGrid ? (e) => {handleShow(index)} : undefined}
                onKeyDown={openGrid ? (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleShow(index)
                  }
                } : undefined}
              />
            );
          case 'VIDEO':
            const options = {
              autoplay: true,
              controls: false,
              children: ['mediaLoader', 'posterImage'],
              setPlaysinline: true,
              playsinline: true,
              muted: true,
              loop: true,
              sources: item.sources.filter(x => x.mimeType !== 'application/x-mpegURL').map((x) => {
                return {src: x.url, type: x.mimeType}
              })
            }

            return (
              <div 
                key={`${handle}imggrid_${index}`}
                className={`${styles.gallvid} ${styles.grid_img} img_${index} ${is_show ? styles.show : ''}`}
                style={{
                  transform: getTrans(index), 
                  zIndex: is_show ? '2' : '1',
                  opacity: is_show || openGrid ? '1' : '0', 
                  visibility: !is_show && firstLoad ? 'hidden' : ''
                }}
                width="400" 
                height="532" 
                role={openGrid ? 'button' : undefined}
                tabIndex={openGrid ? '0' : undefined}
                onClick={openGrid ? (e) => {handleShow(index)} : undefined}
                onKeyDown={openGrid ? (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleShow(index)
                  }
                } : undefined}
              >
                <VideoBg 
                  options={options}
                  vidclasses={styles.tile_vid}
                  key={`${tile_ind}_{index}`}
                  off={!(changeSrc || index < 2 || index === currShow)}
                  />
              </div>
            );
          default:
            return ''
        }
      })}
    </>
  )

  return (
    <>
      {linked ? (
        <Flink
          href={`/products/${handle}`}
          className={`${styles.img_grid} ${styles.tile_grid} ${openGrid ? styles.on : ''} ${isOff ? styles.hovoff : ''}`}
          aria-label={title}
          {...(!isMobile ? { 
            onMouseEnter: (e)=>{handleMouseEnter()}, 
            onMouseLeave: (e)=>{handleMouseEnter(false)} 
          } : {})}
          onClick={handleClick}
          ref={gridRef}
          {...swipers}
        >
          {content}
        </Flink>
      ) : (
        <div 
          className={`${styles.img_grid} ${styles.hovoff} ${!is_pdp ? styles.tile_grid : ''} ${openGrid ? styles.on : ''}`}
          {...(!isMobile ? { 
            onMouseEnter: (e)=>{handleMouseEnter()}, 
            onMouseLeave: (e)=>{handleMouseEnter(false)} 
          } : {})}
          onClick={is_pdp ? handleGrid : undefined}
          onKeyDown={is_pdp ? handleGrid : undefined}
          ref={gridRef}
          {...swipers}
        >
          {content}
        </div>
      )}

      {((vintage && media.length > 1) || (!isMobile && media.length > 2)) && (
        <>
          <button 
            type="button"
            className={[aria_btn, styles.arrows].join(' ')}
            onClick={(e)=> img_back()}
            arr=''
            aria-label='Show previous image'
            aria-hidden={dot === 0 ? 'true' : 'false'}
          >
            <IconChevLeft />
          </button>
          <button 
            type="button"
            className={[aria_btn, styles.arrows, styles.arrow_right].join(' ')}
            onClick={(e)=> img_forw()}
            arr=''
            aria-label='Show next image'
            aria-hidden={'false'}
          >
            <IconChevRight />
          </button>
        </>
      )}
      {isMobile && media.length > 1 && (
        <div className={styles.indicate}>
          {media.map((x,index) => 
            <div key={`dot${index}`} className={[styles.ind_dot, dot === index ? styles.curr : ''].join(' ')} />
          )}
        </div>
      )}
    </>
  )
}

export default ImgGrid




